import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { getTageKeyByValue } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { useTranslation } from 'react-i18next';

export function BerechnungsartExakt() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.exakt',
        )}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.label',
        )}
      </span>
      <div>
        {data.bezahlung.sollstunden.arbeitstage
          .sort((a, b) => a - b)
          .map((arbeitstag, index) => (
            <span
              key={`${arbeitstag}-${index}`}
              className="text-neutrals-900 font-semibold">
              {t(
                'general.date.days.' + getTageKeyByValue(arbeitstag) + 'Short',
              )}
              {'.'}
              {index < data.bezahlung.sollstunden.arbeitstage.length - 1 &&
                ', '}
            </span>
          ))}
      </div>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {data.bezahlung.sollstunden.tagessoll +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.zusammenfassungSuffix',
          )}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        <span>
          {data.bezahlung.sollstunden.unbezahlteUeberstundenMonat ?? '00:00'}
        </span>
        <span>
          {` ${t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.zusammenfassungSuffix',
          )}`}
        </span>
      </span>
    </>
  );
}
